import * as React from 'react'
import { IGifSingleProps } from "./IGifSingleProps";
import { IGifSingleState } from "./IGifSingleState";
import fb from 'src/assets/images/_fb.png'
import tw from 'src/assets/images/_tw.png'
import ins from 'src/assets/images/_ins.png'
import like from 'src/assets/images/like.png'
import share from 'src/assets/images/share.png'
import code from 'src/assets/images/code.png'
import HeaderComponent from "../../components/homeHeader";
import MenuComponent from "../../components/menuComponent/MenuComponent";
import { connect } from "react-redux";
import Backend from "../../api/Backend";
import FavoriteBtnComponent from "../../components/favoriteBtnComponent/FavoriteBtnComponent";
import * as gifActions from "../../actions/gifAction";
import { toast, ToastContainer } from "react-toastify";
import Loader from 'react-loader-spinner'
import axios from "axios";
import { Link, withRouter } from 'react-router-dom'
import {
    FacebookShareButton,
    FacebookIcon
} from 'react-share';
import { Placeholder } from 'semantic-ui-react'
import MasonryComponent from "../../components/masonryComponent/MasonryComponent"
import FooterComponent from "../../components/footerComponent/FooterComponent";
import MenuLeftComponent from "../../App";
import { slide as Menu } from 'react-burger-menu'
import MenuLeftemobile from "../../components/menuLeftMobile/MenuLeftemobile";


class Gifsingle extends React.Component<IGifSingleProps, IGifSingleState> {

    constructor(props: IGifSingleProps) {
        super(props)
        this.state = {
            data: {}, user: {},
            params: this.makeQueryWithTags([]), // empty array -> empty query,
            loading: true
        };
    }


    makeQueryWithTags(tags: Array<any>): object {
        const shoulds = []
if (tags && tags.length > 0){
        tags.map((tag) => {
            const match = {}
            match['tags.text'] = tag.text
            shoulds.push({ match })
        })

        const q = {
            query: {
                nested: {
                    path: "tags",
                    query: {
                        bool: {
                            should: shoulds
                        }
                    }
                }
            }
        }

        return q
}
    }

    componentDidMount() {
        this.setState({ loading: true })

        const id = this.props.match.params.id

		let { gifs } = this.props

		if (gifs) {
			let filteredGifs = gifs.filter(gif => gif.id == id)

            if (filteredGifs.length == 0) {
                this.props.handleGetGif(id, () => {
                })
            } else {
                const currentGif = filteredGifs[0]
                if (this.props.authenticated && currentGif.ownerUserId == this.props.user.uid) {
                    this.setState({
                        user: this.props.user,
                        data: currentGif,
                        params: this.makeQueryWithTags(currentGif.tags),
                        loading: false
                    })
                } else {
                    Backend
                        .database()
                        .ref('users/' + currentGif.ownerUserId)
                        .once('value')
                        .then((snapshot) => {
                            this.setState({
                                user: snapshot.val(),
                                data: currentGif,
                                params: this.makeQueryWithTags(currentGif.tags),
                                loading: false
                            })
                        })
                }
            }
        }

  axios.get('https://europe-west1-ttgif-3c665.cloudfunctions.net/view?id='+id).then(res =>{
      console.log(res.data)
  })

    }

    componentWillReceiveProps(nextProps: Readonly<IGifSingleProps>, nextContext: any): void {

        if (nextProps.openSide === this.props.openSide ) {
            this.setState({loading: true, data: {}, user: {}}, () => {
                const id = nextProps.match.params.id

                console.log(id, 'nextpropId')
                let {gifs, authenticated, user} = nextProps

                if (gifs) {
                    let filteredGifs = gifs.filter(gif => gif.id == id)

                    if (filteredGifs.length == 0) {
                        nextProps.handleGetGif(id, () => {
                        })
                    } else {
                        const currentGif = filteredGifs[0]
                        if (nextProps.authenticated && currentGif.ownerUserId == nextProps.user.uid) {
                            this.setState({
                                user: nextProps.user,
                                data: currentGif,
                                params: this.makeQueryWithTags(currentGif.tags),
                                loading: false
                            })
                        } else {
                            Backend
                                .database()
                                .ref('users/' + currentGif.ownerUserId)
                                .once('value')
                                .then((snapshot) => {
                                    this.setState({
                                        user: snapshot.val(),
                                        data: currentGif,
                                        params: this.makeQueryWithTags(currentGif.tags),
                                        loading: false
                                    })
                                })
                        }
                    }
                }
                axios.get('https://europe-west1-ttgif-3c665.cloudfunctions.net/view?id=' + id).then(res => {
                    console.log(res.data)
                })
            })
        }

    }

	copyToClipboard() {
		console.log('innnn')
		let textArea = document.createElement("textarea");
		textArea.style.position = 'fixed';
		textArea.style.top = '0';
		textArea.style.left = '0';

		// Ensure it has a small width and height. Setting to 1px / 1em
		// doesn't work as this gives a negative w/h on some browsers.
		textArea.style.width = '2em';
		textArea.style.height = '2em';

		// We don't need padding, reducing the size if it does flash render.
		textArea.style.padding = '0';

		// Clean up any borders.
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';

		// Avoid flash of white box if rendered for any reason.
		textArea.style.background = 'transparent';


		//let text = location.origin + '/media_gif/' + this.state.data.id ;
		textArea.value = `http://media.giftounsi.tn/share?id=${this.state.data.id}`
		document.body.appendChild(textArea);

		textArea.focus();
		textArea.select();
		document.execCommand('copy');
		document.body.removeChild(textArea);

		console.log('mriigl')
		toast('text copié')


	};


    handleSearchByTag(tag) {
        event.preventDefault();
        this.props.handleSearch([tag], () => {
            this.props.history.push({ pathname: '/search',
                state :tag })
        })
    }


	public render() {

        return (

			document.queryCommandSupported('copy') &&

            <div style={{display: 'flex', flexDirection: 'column'}}>
                <MenuLeftemobile />

                <HeaderComponent />
                <MenuComponent />
                <ToastContainer />
                <div style={{flex: 1}}>


                    <div className="_difContent">
                        <div className="container">
                            {<div className="_nextprevRow">
                            </div>}
                            <div className="content">
                                <div className="row">
                                    <div className="col _info info_resp" style={{ maxWidth: '150px' }}>
                                        {this.state.loading
                                            ?
                                            <Placeholder>
                                                <Placeholder.Image square/>
                                            </Placeholder>
                                            :
                                            (<div className="_img ">
                                                {this.state.user && this.state.user.photo ?
                                                    (this.state.user.photo.includes('graph.facebook.com') ?
                                                        <img className='_img_resp' src={this.state.user.photo + '?width=500'}
                                                            alt="gif title " />
                                                        : <img className='_img_resp' src={this.state.user.photo} alt="gif title " />
                                                    ) : null}
                                            </div>)}
                                        {this.state.loading
                                            ?
                                            <Placeholder
                                                style={{
                                                    width: '400px',
                                                    height: '15px',
                                                    display: 'flex',
                                                    flexDirection: 'row'
                                                }}>
                                                <Placeholder.Header>
                                                    <Placeholder.Line
                                                        style={{
                                                            width: '100px',
                                                            height: '15px',
                                                        }}
                                                    />
                                                    <Placeholder.Line
                                                        style={{
                                                            width: '100px',
                                                            height: '15px',
                                                        }} />
                                                </Placeholder.Header>
                                            </Placeholder>
                                            :
                                            (<div className="name">
                                                {this.state.user && this.state.user.name ?
                                                    this.state.user.name
                                                    : null}
                                            </div>)}

                                        <div className="follow">
                                            <div className="title">
                                                suivre sur
                                                </div>
                                            <div className="row">{this.state.user.facebook ?
                                                <div className="col">
                                                    <a className="facebook" href={this.state.user.facebook} > <img src={fb} /></a>
                                                </div> : null}
                                                {this.state.user.twitter ?
                                                    <div className="col">
                                                        <a className="twitter" href={this.state.user.twitter}> <img src={tw} /></a>
                                                    </div> : null}
                                                {this.state.user.instagram ? <div className="col">
                                                    <a className="instagram" href={this.state.user.instagram}> <img src={ins} /></a>
                                                </div> : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col _content">
                                        {this.state.loading
                                            ?
                                            <Placeholder
                                                style={{
                                                    width: '200px',
                                                    height: '30px'
                                                }}
                                            >
                                            </Placeholder>
                                            :
                                            (<h2>{this.state.data.title}</h2>)}

                                        {this.state.loading
                                            ?
                                            <Placeholder>
                                                <Placeholder.Image
                                                    square
                                                >
                                                </Placeholder.Image>
                                            </Placeholder>
                                            :
                                            (<div className="_img">



                                                <img src={this.state.data.URL} alt={this.state.data.title} />
                                            </div>)}


                                        <div className="_tags">
                                            {
                                                this.state.data && this.state.data.tags
                                                &&
                                                this.state.data.tags.map((tag, index) => (
                                                    <div className='tag' onClick={()=>this.handleSearchByTag(tag.text)} key={index}>{tag.text}</div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <div className="col _share">
                                        <div className="emptyspace"></div>
                                        <div className="supShare">
                                            <FavoriteBtnComponent
                                                user={this.props.user}
                                                gif={this.state.data} />
                                        </div>
                                        <div className="supShare" onClick={() => this.copyToClipboard()}>
                                            <div className="_supImg"><img src={share} alt="share icon" /></div>
                                            <a className="_supTitle" href="#"> Copier le lien</a>
                                        </div>
                                        <div className="supShare">
                                            {/* <div className="_supImg"><img src={code} alt="share icon" /></div>
                                            <a className="_supTitle" href="#"> share</a> */}
                                            <div>
                                                <div style={{
                                                    marginTop: '20px'
                                                }}>
                                                    <FacebookShareButton
                                                        //url={`http://c79f0b70.ngrok.io/media_gif/${this.state.data.id}`}
                                                        url={`http://media.giftounsi.tn/share?id=${this.state.data.id}`}
                                                        //url={'https://firebasestorage.googleapis.com/v0/b/ttgif-3c665.appspot.com/o/gifs%2FX1552934768937?alt=media&amp;token=407cb3d2-9f88-4a48-83df-9326743f8b93'}
                                                        //url={location.origin + '/media_gif/' + this.state.data.id}
                                                        //quote={this.state.data.title}
                                                    >
                                                        <FacebookIcon
                                                            size={32}
                                                        />
                                                    </FacebookShareButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="_coloredBanner gifpart">
                        <div className="container">
                            {
                                !this.state.loading
                                    ? <MasonryComponent
                                        title={'GIF SMILAIRES'}
                                        size={20}
                                        url='https://search.giftounsi.placeholder.tn/gifs/_search'
                                        params={this.state.params}
                                        elastic={true}
                                        similaire={this.state.data}
                                    />
                                    : <Loader type="Plane" color="#f34c71" height={80} width={80} />
                            }
                        </div>
                    </section>
                </div>
                <FooterComponent/>
            </div>
        )
    }
}


function mapsStateToProps(state) {
	return {
		errorMessage: state.auth.errorMessage,
		authenticated: state.auth.authenticated,
		user: state.auth.currentUser,
		newGif: state.Gif.newGif,
		gifPost: state.Gif.gifPost,
		gifs: state.Gif.gifs ,
        openSide : state.toast.openSide

    };
}

const mapDispatchToProps = (dispatch: any, ownProps: IGifSingleProps) => {
	return {
		handleGetGif: (gifId, cb) => dispatch(gifActions.getGif(gifId, cb)),
        handleSearch: (text, cb) => dispatch(gifActions.search(text, cb))

    }
}

export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(Gifsingle))



// WEBPACK FOOTER //
// ./src/containers/gifSingle/gifsingle.tsx